import Axios from "axios";
import {
    SET_CMS_DOCUMENT_LIST,
    UNSET_CMS_DOCUMENT_LIST
} from "@/store/mutation-types";

import { 
    getCmsFiles,
    uploadCmsFile,
    sendDocumentApproval,
    showCmsFile,
    downlosdCmsFileUrl,
} from "@/store/api";

const state = {
    getDocumentsList: [],
};

const getters = {
    getDocumentsList(state) {
        return state.getDocumentsList;
    },
};

const mutations = {
    [SET_CMS_DOCUMENT_LIST](state, data) {
        state.getDocumentsList = data;
    },
    [UNSET_CMS_DOCUMENT_LIST](state) {
        state.getDocumentsList = [];
    },
};

const actions = {

    saveCmsDocuments({ commit }, { formData, onProgress, signal }) {
        commit("SET_LOADING", { color: "primary" });

        return new Promise((resolve, reject) => {
            const axiosConfig = {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                onUploadProgress: (progressEvent) => {
                    if (progressEvent.lengthComputable) {
                        const percentComplete = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        if (typeof onProgress === 'function') {
                            onProgress(percentComplete);
                        }
                    }
                },
            };

            if (signal) {
                axiosConfig.signal = signal;
            }

            Axios.post(uploadCmsFile, formData, axiosConfig)
            .then((response) => {
                if (typeof onProgress === 'function') {
                    onProgress(100);
                }
                resolve(response);
            })
            .catch(function (error) {
                reject(error);
            })
            .then(() => {
                commit("UNSET_LOADING");
            });
        });
    },

    getDocumentsList({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", { color: "primary" });
            
            Axios.get(getCmsFiles, { params: data })
                .then((response) => {
                    commit('SET_CMS_DOCUMENT_LIST', response.data.data);
                    resolve(response);
                })
                .catch((error) => {
                    commit('UNSET_CMS_DOCUMENT_LIST');
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

    sendDocumentApproval({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", { color: "primary" });

            Axios.post(sendDocumentApproval, data)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getDocumentsList({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", { color: "primary" });
            
            Axios.get(getCmsFiles, { params: data })
                .then((response) => {
                    commit('SET_CMS_DOCUMENT_LIST', response.data.data);
                    resolve(response);
                })
                .catch((error) => {
                    commit('UNSET_CMS_DOCUMENT_LIST');
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getFileById({ commit }, data) {
        const url =  showCmsFile(data);
        commit("SET_LOADING", {color: "primary"});  
        return new Promise((resolve, reject) => {
        Axios.get(url)
            .then((response) => {
            resolve(response.data.data);
            commit("UNSET_LOADING"); 
            })
            .catch((error) => {
            reject(error);
            commit("UNSET_LOADING"); 
            });
        });
    },

    downlosdCmsFile({ commit }, { fileId, type=null}) {
        let url = downlosdCmsFileUrl(fileId);
        if (type) { url += `?type=${type}`;}

        commit("SET_LOADING", { color: "primary" });

        return Axios.get(url, {
            responseType: "blob"
        })
        .then((response) => {
        commit("UNSET_LOADING");
        return response.data;
        })
        .catch((error) => {
        commit("UNSET_LOADING");
        throw error;
        });
    },


};

export default {
    state,
    getters,
    actions,
    mutations,
};
